import './tabs-home.scss';
import { NavLink } from "react-router-dom";
import TranslateService from '../../services/translate-service';
import UtilsService from '../../services/utils-service';

export default function TabsHome() {
    return (
        <div className="tabs-home flex mx-auto">
            <NavLink to="/" className={ ({ isActive }) => isActive ? 'active' : '' }>
                <div className='tabs-option ' >
                {UtilsService.capitalize(TranslateService.get('navbar.tabs.individualchallenge'))}
                </div>
            </NavLink>
            <NavLink to="/team-challenge" className={ ({ isActive }) => isActive ? 'active' : '' } >
                <div className='tabs-option'>
                {UtilsService.capitalize(TranslateService.get('navbar.tabs.teamchallenge'))}
                </div>
            </NavLink>
            <NavLink to="/support-materials" className={ ({ isActive }) => isActive ? 'active' : '' } >
                <div className='tabs-option'>
                {UtilsService.capitalize(TranslateService.get('navbar.tabs.supportMaterial'))}
                </div>
            </NavLink>
        </div>
    );
}
